import styled from "styled-components";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";

export const InfoDialogContent = styled(DialogContent)`
    text-align: center;
`;



// WEBPACK FOOTER //
// ./src/mobile/InfoDialog/InfoDialog.sc.js